const urlSource = {
	events() {
		if (!new URLSearchParams(window.location.search).has('utm_source')) return

		const date = new Date()
		let socialSourceCookie = ''

		const getCookieValue = (cookieName) => {
			const cookieString = document.cookie
				.split('; ')
				.find(row => row.startsWith(cookieName + '='))
			return cookieString ? decodeURIComponent(cookieString.split('=')[1]) : null
		}

		// Get the Portugal time using Intl.DateTimeFormat
		const options = { timeZone: 'Europe/Lisbon', hour12: false }
		const formatter = new Intl.DateTimeFormat('en-CA', {
			...options,
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit'
		})

		// Format the date and extract parts
		const [datePart, timePart] = formatter.format(date).split(', ')
		const formattedDate = `${datePart}T${timePart}`

		let socialSourceObj = {}

		const splitUrl = window.location.href.split('?')
		const queryStringBreak = splitUrl[1].split('&')

		queryStringBreak.forEach( item => {
			const keyPair = item.split('=')
			socialSourceObj[keyPair[0]] = keyPair[1]
		})

		socialSourceObj.date = formattedDate
		socialSourceObj.url = String(window.location.href)

		const storageConsent = localStorage.getItem('__unic_consent_mode')
		const parsedStorageConsent = JSON.parse(storageConsent)

		if (storageConsent && parsedStorageConsent['ad_storage'] === 'granted') {
			if(document.cookie && document.cookie.includes('social_media_source=')) {
				socialSourceCookie = JSON.parse(getCookieValue('social_media_source'))
				socialSourceCookie.push(socialSourceObj)
				document.cookie = `social_media_source=${encodeURIComponent(JSON.stringify(socialSourceCookie))}; path=/`
			} else {
				socialSourceCookie = []
				socialSourceCookie.push(socialSourceObj)

				document.cookie = `social_media_source=${encodeURIComponent(JSON.stringify(socialSourceCookie))}; path=/`
			}
		} else {
			socialSourceCookie = []
			socialSourceCookie.push(socialSourceObj)
            
			sessionStorage.setItem('social_media_source', encodeURIComponent(JSON.stringify(socialSourceCookie)))
		}
	},

	init() {
		this.events()
	}
}

urlSource.init()
